module.exports = __webpack_public_path__ + "static/media/utilita1.10efe659.png";